/* eslint-disable no-unused-vars */
async function initMap() {
  const $map = $("#js-map");
  const mapElement = $map.get(0);

  if (!mapElement) return;

  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } =
    await google.maps.importLibrary("marker");

  const lat = parseFloat($map.attr("data-lat"));
  const lng = parseFloat($map.attr("data-lng"));
  const zoom = parseInt($map.attr("data-zoom"), 10);
  const mapId = $map.attr("data-map-id");
  const center = { lat, lng };

  const map = new Map(mapElement, {
    center,
    zoom,
    mapId,
  });

  const pin = new PinElement({
    scale: 1.5,
    background: "#84C176",
    borderColor: "#006666",
    glyphColor: "#006666",
  });

  const marker = new AdvancedMarkerElement({
    map,
    position: center,
    content: pin.element,
  });
}
